import React from 'react';
import BaseComponent from 'src/components/BaseComponent';
import { MCButton, MCError, Spinner, TabMenu, TextField } from 'src/components/basic';
import AlertManager from 'src/components/alert/AlertManager';
import PopupSelect from 'src/components/complex/popupSelect';

import { withRouter, lang, remCss, addressObject } from 'src/helpers';
import { BASE_ICONS } from 'src/components/svg';

import model from '../invitationsModel';
import mainModel from '../model';
import ShortInfo from 'src/components/user/ShortInfo';
import LANG_CONST from 'src/helpers/lang/const';
import Bulk, { ImportBtn } from './Bulk';

class CreateDoctor extends BaseComponent {
  componentDidMount() {
    model.baseSubscribe(this.subscription);
    model.on('accountSwitched', this.init);
    this.init();
  }

  init = () => {
    model.resetApiState('invite');
    model.resetApiState('update');
    model.resetInviteInput();
    if (this.props.router.params.id) {
      model.getInvite(this.props.router.params.id, () => {
        this.setTab({ id: this.props.router.params?.id ? 'invite' : 'search' });
      });
    }
    this.setTab({ id: this.props.router.params?.id ? 'invite' : 'search' });
  };
  setTab = (tab) => {
    model.resetApiState('update');
    model.resetApiState('invite');
    this.apiStateId = 'invite';

    model.setState({ tab: tab.id });
  };

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.cancel('accountSwitched', this.init);
  }

  renderInvite = () => {
    const apiStateId = this.apiStateId;
    const createState = model.getApiState(apiStateId);
    const { invalid } = createState;
    const handleChange = model.handleChange;

    return (
      <>
        <div
          className={'mc-container-content__body-content border'}
          style={{ alignItems: 'center' }}
        >
          <div
            className={'mc-flex-20-col'}
            style={{ width: '100%', maxWidth: remCss(700), marginTop: remCss(10) }}
          >
            <div className={'mc-flex-20'}>
              <TextField
                label='Full name'
                disabled={!!this.props.router.params?.id}
                placeholder='Enter full name'
                value={model.input('fullname')}
                name={'fullname'}
                onChange={(n, v) => {
                  model.resetApiState(apiStateId);
                  handleChange(n, v);
                }}
                template={6}
                onBlur={model.handleBlur}
                invalid={invalid}
              />
            </div>
            <div className={'mc-flex-20 mc-flex-start'}>
              <TextField
                label='Email'
                disabled={!!this.props.router.params?.id}
                placeholder='uname@mail.com'
                type='email'
                name='email'
                value={model.input('email')}
                onChange={(n, v) => {
                  model.resetApiState(apiStateId);
                  handleChange(n, v);
                }}
                template={6}
                onBlur={model.handleBlur}
                invalid={invalid}
              />
              <TextField
                template={6}
                disabled={!!this.props.router.params?.id}
                defaultCountryName={model.state.tempCountryAddress}
                name={'phoneNumber'}
                type='phone'
                value={model.input('phoneNumber').toString()}
                onChange={(n, v) => {
                  model.resetApiState(apiStateId);
                  handleChange(n, v);
                }}
                onBlur={model.handleBlur}
                label={'Phone number'}
                invalid={invalid}
              />
            </div>
            {invalid?.emailOrPhone && (
              <MCError mcTextProps={{ primary: true }} error={invalid?.emailOrPhone} />
            )}
            <div className={'mc-flex-20'}>{this.renderLocation()}</div>
            {createState.error && (
              <div className={'mc-flex'}>
                <p className='mc-error'>{createState.errorMessage}</p>
              </div>
            )}
          </div>
        </div>
        {this.renderFooter()}
      </>
    );
  };

  renderLocation = () => {
    const apiStateId = this.apiStateId;
    const createState = model.getApiState(apiStateId);
    const { invalid } = createState;
    const handleChange = model.handleChange;

    return (
      <PopupSelect
        template={6}
        isMultiple={true}
        isClearable={false}
        placeholder={'Select'}
        label={'Locations'}
        description={LANG_CONST.text.select_location_des}
        NoResultsElement={({ hide }) => (
          <div>
            <div>{lang.t(LANG_CONST.text.need_location)}</div>
            <div style={{ marginTop: remCss(20), display: 'flex', justifyContent: 'center' }}>
              <MCButton
                primary
                dark
                medium
                radius
                label='Add location'
                onClick={() => {
                  this.navigate('/settings/location');
                  hide();
                }}
              />
            </div>
          </div>
        )}
        defaultValue={false}
        initSelectedParamKey={'hospitalIds'}
        apiConfig={{
          url: 'clinic/manager/hospitals',
          activeDoctors: true,
          labelFn: (item) => (
            <div className={'mc-flex-0-col'}>
              <div className={'mc-text-518'}>{item.hospital?.split('_')[0]}</div>
              <div className={'mc-label-416'}>
                {
                  addressObject({
                    cityAddress: item.city,
                    stateAddress: item.state,
                    countryAddress: item.country
                  }).fullAddressNameReverse
                }
              </div>
            </div>
          )
        }}
        name={'hospitalIds'}
        invalid={invalid}
        value={model.input('hospitalIds')}
        onChange={(n, v, a) => {
          model.resetApiState(apiStateId);
          handleChange(n, v);
          model.setStateSilent({ hospitals: a?.map((a) => a.item) });
        }}
      />
    );
  };

  renderSearch = () => {
    const apiStateId = this.apiStateId;
    const createState = model.getApiState(apiStateId);
    const { invalid } = createState;

    return (
      <>
        <div
          className={'mc-container-content__body-content border'}
          style={{ alignItems: 'center' }}
        >
          <div
            className={'mc-flex-20-col'}
            style={{ width: '100%', maxWidth: remCss(450), marginTop: remCss(10) }}
          >
            <div className={'mc-flex-20'}>
              <PopupSelect
                template={6}
                isPopover={true}
                isClearable={false}
                label={lang.t(LANG_CONST.text.select_text, { attr: lang.t(LANG_CONST.doctor) })}
                placeholder={LANG_CONST.select}
                name={'doctor'}
                invalid={invalid}
                value={model.state.doctor?.id}
                initSelectedParamKey={'doctorId'}
                apiConfig={{
                  url: 'account/findAvailableDoctorsForClinic',
                  prioritizeRole: 'doctor',
                  clinicId: model.state.user?.managerToClinic,
                  labelFn: (user) => <ShortInfo small user={user} specialist={[]} />
                }}
                selectedLabelFn={(user) => (
                  <ShortInfo
                    small
                    user={user}
                    specialist={[]}
                    style={{
                      marginTop: remCss(-3),
                      marginBottom: remCss(-3),
                      cursor: 'pointer'
                    }}
                  />
                )}
                onChange={(n, v, a) => {
                  model.resetApiState(apiStateId);
                  model.setState({ doctor: a.item });
                }}
              />
            </div>
            <div className={'mc-flex-20'}>{this.renderLocation()}</div>
            {createState.error && (
              <div className={'mc-flex'}>
                <p className='mc-error'>{createState.errorMessage}</p>
              </div>
            )}
          </div>
        </div>
        {this.renderFooter()}
      </>
    );
  };

  renderFooter = () => {
    const createState = model.getApiState('invite');
    const loading = createState.loading || model.getApiState('update').loading;
    return (
      <div className={'mc-container-content__body-footer'}>
        <div className={'mc-flex'}>
          <div className={'mc-grow'}></div>
          <MCButton
            primary
            medium
            light
            style={{ minWidth: remCss(80) }}
            radius
            label={LANG_CONST.buttons.cancel}
            to={'/doctors'}
            type={'link'}
          />
          {model.state.tab === 'import' ? (
            <MCButton
              primary
              medium
              dark
              style={{ minWidth: remCss(100) }}
              radius
              label={LANG_CONST.buttons.send_invite}
              onClick={() => {}}
            />
          ) : !this.props.router.params?.id ? (
            <MCButton
              primary
              medium
              dark
              radius
              style={{ minWidth: remCss(100) }}
              loading={loading}
              disabled={loading}
              label={'Send invite'}
              onClick={() => {
                if (model.state.tab === 'search' && !model.state.doctor) {
                  model.setInvalidApi(this.apiStateId, {
                    length: 1,
                    doctor: 'Doctor is required.'
                  });
                } else {
                  model.sendInvite(this.props.router.params.id, (err, data, success) => {
                    if (success) {
                      this.back();
                      mainModel.setState({ tab: 'invitations' });
                      AlertManager.popup(AlertManager.TYPES.INFO, {
                        close: false,
                        width: 460,
                        title: lang.t(LANG_CONST.notice.sent_invitation, {
                          type: lang.t(LANG_CONST.doctor).toLowerCase()
                        }),
                        actionButton: {
                          label: LANG_CONST.buttons.ok,
                          action: (actions) => {
                            actions.hide();
                          }
                        }
                      });
                    }
                  });
                }
              }}
            />
          ) : (
            <MCButton
              primary
              medium
              dark
              radius
              style={{ minWidth: remCss(100) }}
              disabled={loading}
              loading={loading}
              label={LANG_CONST.buttons.edit}
              onClick={() => {
                model.updateInvite(parseInt(this.props.router.params.id), (err, data, success) => {
                  if (success) {
                    AlertManager.popup(AlertManager.TYPES.INFO, {
                      close: false,
                      title: LANG_CONST.notice.change_success,
                      width: 400,
                      cancelButton: {
                        label: LANG_CONST.buttons.ok,
                        action: (actions) => {
                          actions.hide();
                        }
                      }
                    });
                  }
                });
              }}
            />
          )}
        </div>
      </div>
    );
  };

  render() {
    if (model.getApiState('invite_detail').loading)
      return (
        <div className={'mc-m-auto'}>
          <Spinner />
        </div>
      );

    const header = (
      <div className={'mc-container-content__header mc-flex'}>
        <MCButton
          onClick={this.back}
          iconname={BASE_ICONS.BACK_ARROW}
          circle
          primary
          dark
          width={40}
        />
        <span className={'mc-grow'}>
          {lang.t(
            this.props.router.params.id
              ? LANG_CONST.titles.edit_doctor
              : LANG_CONST.titles.add_doctor
          )}
        </span>
      </div>
    );

    return (
      <div className={'mc-container-content'}>
        {header}
        <div className={'mc-container-content__body'}>
          {!this.props.router.params.id && (
            <div
              className={'mc-container-content__body-header mc-add-patient'}
              style={{ margin: remCss(25) }}
            >
              <div>
                <TabMenu
                  tabs={[
                    { id: 'search', name: LANG_CONST.search },
                    { id: 'invite', name: LANG_CONST.invite },
                    { id: 'bulk', name: LANG_CONST.bulk }
                  ]}
                  tab={{ id: model.input('tab') }}
                  type={'button'}
                  setTab={(v) => {
                    model.resetApiState(this.apiStateId);
                    model.handleChange('tab', v.id);
                  }}
                />
              </div>
              <div className={'mc-grow'} />
              {model.state.tab === 'bulk' && <ImportBtn />}
            </div>
          )}
          {model.state.tab === 'search' && this.renderSearch()}
          {model.state.tab === 'invite' && this.renderInvite()}
          {model.state.tab === 'bulk' && <Bulk />}
        </div>
      </div>
    );
  }
}

export default withRouter(CreateDoctor);
